module.exports = __webpack_public_path__ + "img/applaud.5fd1b20e.svg";